import * as types from "./actionTypes";

export {
  userCheckIsLoggedIn,
  userAttemptLogin,
  userAttemptSignup,
  userAttemptForgottenPassword,
  setIsAuthenticating,
  authSetLoggedIn,
  userAttemptLogout,
  authSetLoggedOut,
  authSetShouldOnboard,
  authSetShouldRedirectToProfile,
  authErrorSet,
} from "./authActions";

export { submitABMForm, abmOnboardingSubmitted } from "./abmActions";

export {
  postGateForm,
  submitGateForm,
  gateOnboardingSubmitted,
} from "./gateActions";

export {
  onboardLoadedState,
  onboardUpdateState,
  setLoadingState,
  setModalState,
  markDocumentRead,
  postReflexAllenOnboardingForm,
  requestReflexAllenPdf,
  setReflexAllenPdf,
  setDownloadingReflexAllenPdf,
  postReflexAllenInductionProgramme,
} from "./onboardActions";

export {
  applyForJob,
  applySetError,
  applySetIsLoading,
  applySuccess,
} from "./jobBoardActions";

export {
  userSetIsLoading,
  creatingUserInProfile,
  updateUserInProfile,
  updateUserInProfileSilent,
  updateCvInProfileSilent,
  getUserInProfile,
  resendConfirmation,
  setError,
  updateGeneralConsent,
  setCvUploadLoading,
  setPendingConfirmation,
  setHasLinkedProfileAccount,
  checkHasLinkedProfileAccount,
  storeUserData,
  setContinuingRegistration,
  continueRegistration,
  setCvProgress,
  submitClientFormSilent,
} from "./userActions";

export {
  getAddressList,
  storeAddressList,
  postcodeSetError,
  postcodeClearError,
} from "./addressActions";

export {
  timesheetsSetIsLoading,
  timesheetsSetData,
  timesheetsRequestData,
  timesheetRequestUpdate,
  timesheetUpdateSuccess,
  timesheetUpdateFailed,
  setNonAttendanceLookupData,
} from "./timesheetsActions";

export {
  bookingsRequestData,
  bookingsSetData,
  bookingsSetIsLoading,
} from "./bookingActions";

export {
  payslipsRequestData,
  payslipsSetData,
  payslipsSetIsLoading,
} from "./payslipActions";

export {
  holidayRequestData,
  holidaySetData,
  holidayHistorySetData,
  holidaySetIsLoading,
  postHolidayRequestForm,
  setHolidayRequestFormLoading,
  setHolidayRequestFormSubmitted,
} from "./holidayActions";

export {
  latestJobsRequestData,
  latestJobsSetData,
  latestJobsSetIsLoading,
} from "./latestJobsActions";

export {
  rightToWorkCheck,
  rightToWorkSuccess,
  rightToWorkError,
  rightToWorkVerificationSetIsLoading,
  rightToWorkVerificationQueueSizeSuccess,
  rightToWorkVerificationQueueDetails,
} from "./rtwActions";

export {
  notificationRequest,
  notificationSuccess,
  notificationError,
  notificationLastReadRequest,
  notificationLastReadSuccess,
  notificationLastReadError,
  notificationReadUpdateRequest,
  notificationReadUpdateSuccess,
  notificationReadUpdateError,
} from "./notificationActions";

export {
  userFeedback,
  userFeedbackDismissal,
  userFeedbackClose,
} from "./feedbackActions";

export {
  uploadDocumentation,
  documentationSuccess,
  documentationError,
} from "./documentationActions";

export {
  postRoyalMailForm,
  submitRoyalMailOnboarding,
  royalMailOnboardingSubmitted,
} from "./royalMailActions";

export {
  postDnataForm,
  submitDnataForm,
  dnataOnboardingSubmitted,
  submitDnataTest,
  dnataTestSubmitted,
  setDnataTestLoading,
  submitDnataExtraForm,
  setDnataExtraFormLoading,
  uploadDnataPdf,
} from "./dnataActions";

export { postSwissportForm, setSwissportLoading } from "./swissportActions";

export {
  setPecanAssessmentLoading,
  submitPecanAssessment,
  submitPecanForms,
  postPecanForms,
  markDocumentReadPecan,
  setPecanReadingLoading,
  submitPecanFormsSuccess,
  submitPecanAssessmentSuccess,
} from "./pecanActions";

export {
  postDrivingForm,
  submitDrivingOnboarding,
  drivingOnboardingSubmitted,
} from "./drivingActions";

export { postNightWorkerForm } from "./formActions";

export { storeWorkHistory } from "./workHistoryActions";

export { storeWorkReferences } from "./workReferencesActions";

export { loadUmbracoContent } from "./umbracoActions";

export { dismissErrorModal } from "./modalActions";

export {
  setGreatBearReadingLoading,
  markDocumentReadGB,
} from "./greatBearActions";

export {
  setKingspanReadingLoading,
  setSOPLoading,
  markDocumentReadKingspan,
  postSOPKingspan,
  postSOPDocumentSuccess,
  setKingspanAssessmentLoading,
  submitKingspanAssessment,
  kingspanAssessmentSubmitted,
} from "./kingspanActions";

export {
  setPusterlaReadingLoading,
  markDocumentReadPusterla,
} from "./pusterla";

export {
  setRegattaReadingLoading,
  markDocumentReadRegatta,
  setRegattaAssessmentLoading,
  submitRegattaAssessment,
  regattaAssessmentSubmitted,
} from "./regattaActions";

export const addError = (source, error) => ({
  type: types.ADD_SERVER_ERROR,
  payload: { source, error },
});

export const clearErrors = (source) => ({
  type: types.CLEAR_SERVER_ERRORS,
  payload: source,
});

export { default as handleAxiosHttpError } from "./errorHandlerActions";

export {
  big5PersonalityTestSubmitted,
  exposureBasedMemoryTestSubmitted,
  nonverbalImmediacyTestSubmitted,
  discAssessmentTestSubmitted,
  setDiscAssessmentTestLoading,
} from "./psychometricTestsActions";

export {
  markDocumentReadCarltonForest,
  setCarltonForestReadingLoading,
  setInductionFormCarltonForestLoading,
  postCarltonForestForm,
  submitCarltonForestForm,
  setInductionFormItemCarltonForestLoading,
  postSSOWCarltonForest,
  setSSOWCarltonForestLoading,
  setSSOWItemsCarltonForestLoading,
} from "./carltonForestActions";

export { postNHSReferenceForm } from "./nhsReferencesActions";

export { submitUmbrellaDeclarationForm } from "./umbrellaActions";

export { markDocumentReadCPI, setCPIReadingLoading } from "./cpiActions";

export {
  markDocumentReadThanetCouncil,
  setThanetCouncilReadingLoading,
  postRiskAssessmentThanetCouncil,
  setThanetCouncilRiskAssessmentLoading,
} from "./thanetCouncilActions";

export { yotiFetchIframeUrl, yotiSetUrl } from "./yotiActions";

export {
  markDocumentReadMolecular,
  setMolecularAssessmentLoading,
  submitMolecularAssessment,
  postMolecularForms,
  molecularAssessmentSubmitted,
} from "./molecularActions";

export { markDocumentReadWoodland, postWoodlandForms } from "./woodlandActions";
export {
  markDocumentReadCompleatFood,
  setCompleatFoodReadingLoading,
  postCompleatFoodForm,
  setCompleatFoodFormLoading,
} from "./compleatFoodActions";
export {
  markDocumentReadGrowUpFarms,
  setGrowUpFarmsReadingLoading,
  setGrowUpFarmsFoodQuestionnaireLoading,
  setGrowUpFarmsFoodQuestionnaireResults,
} from "./growUpFarmsActions";
export {
  markDocumentReadDavinFoods,
  setDavinFoodsReadingLoading,
  submitDavinFoodsQuiz,
  setDavinFoodsQuizLoading,
  setDavinFoodsQuizResults,
  submitDavinFoodsForm,
  postDavinFoodsForm,
  setDavinFoodsQuizShowResults,
} from "./davinFoodsActions";

export { postIpnForm, setIpnLoading } from "./ipnActions";

export { updateDetailsStoreDate } from "./updateDetailsPrompt";
